import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addEvaluation, resetEvaluationStatus } from '../../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import '../index.css'


function EvaluationForm (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        reviewedStudent: "",
        message: "",
        loading: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        let newState = {}
        for (let i = 0; i < props.sprint.questionAnswerTypePairs.length; i++) {
            newState[i + ":" + props.sprint.questionAnswerTypePairs[i].question] = "";
        }
        setState({...state, ...newState});
    }, []);

    const getMappedStudents = () => {
        return props.classStudents && props.classStudents
            .sort((a, b) => {
                if(a.lastName.toLowerCase() < b.lastName.toLowerCase()) return -1;
                if(a.lastName.toLowerCase() > b.lastName.toLowerCase()) return 1;
                return 0;
            })
            .map((student, index) => {
            return (
                <MenuItem
                    key={index + student.firstName}
                    value={student.lastName + ", " + student.firstName}
                    primaryText={student.lastName + ", " + student.firstName}
                    id="reviewedStudent"
                    onClick={() => handleStudentDropdownChange(student._id)}
                />
            );
        })
    }

    const getMappedQuestionsAnswerPairs = () => {
        return props.sprint.questionAnswerTypePairs !== undefined ?
            props.sprint.questionAnswerTypePairs.map((questionAnswer, index) => {
                if (questionAnswer.answer === "Text") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <TextField
                                hintText="Answer"
                                name={index + ":" + questionAnswer.question}
                                onChange={handleChange}
                                value={state[index + ":" + questionAnswer.question]}
                                multiLine={true}
                                rows={1}
                                style={{width: "90%", maxWidth: "500px"}}
                            />
                        </div>
                    )
                } else if (questionAnswer.answer === "Range") {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="1"
                                            checked={state[index + ":" + questionAnswer.question] === "1"}
                                        />
                                    1
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="2"
                                            checked={state[index + ":" + questionAnswer.question] === "2"}
                                        />
                                    2
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="3"
                                            checked={state[index + ":" + questionAnswer.question] === "3"}
                                        />
                                    3
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="4"
                                            checked={state[index + ":" + questionAnswer.question] === "4"}
                                        />
                                    4
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="5"
                                            checked={state[index + ":" + questionAnswer.question] === "5"}
                                        />
                                    5
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="6"
                                            checked={state[index + ":" + questionAnswer.question] === "6"}
                                        />
                                    6
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="7"
                                            checked={state[index + ":" + questionAnswer.question] === "7"}
                                        />
                                    7
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="evaluationQuestion" key={index + questionAnswer.question}>
                            <h2>{questionAnswer.question}</h2>
                            <div className="rangeResponse">
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="Yes"
                                            checked={state[index + ":" + questionAnswer.question] === "Yes"}
                                        />
                                        Yes
                                    </label>
                                </div>
                                <div className="evalRadio">
                                    <label>
                                        <input
                                            type="radio"
                                            name={index + ":" + questionAnswer.question}
                                            onChange={handleChange}
                                            value="No"
                                            checked={state[index + ":" + questionAnswer.question] === "No"}
                                        />
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    )
                }
            }) : null;
    }

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleStudentDropdownChange = (studentId) => {
        setState({
            ...state,
            reviewedStudent: studentId
        });
    }

    const handleSubmit = () => {
        setState({...state, loading: true});
        props.resetEvaluationStatus();
        const questionAnswerPairs = []
        let entry;
        let pointsForReviewed = 0;
        for (let key in state) {
            if (key === "reviewedStudent") {
                if (state[key] === "") {
                    setState({...state, message: "You must answer all of the questions.", loading: false})
                    return
                }
            } else if (key !== "message" && key !== "loading") {
                if (state[key] === "") {
                    setState({...state, message: "You must answer all of the questions.", loading: false})
                    return
                } else {
                    entry = props.sprint.questionAnswerTypePairs.find(pair => pair.question === key.split(":")[1])
                    if (entry.answer === "Range") {
                        pointsForReviewed += parseInt(state[key], 10)
                        questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Range"})
                    } else if (entry.answer === "Y/N") {
                        questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Y/N"})
                    } else {
                        questionAnswerPairs.push({question: key.split(":")[1], answer: state[key], type: "Text"})
                    }
                }
            }
        }

        const student = props.classStudents.find(student => student._id === state.reviewedStudent);
        try {
          props.addEvaluation(
            {
              questionAnswerPairs,
              pointsForReviewed,
              assignment: props.assignment._id,
              status: "StudentSubmitted",
              nameOfReviewedStudent:
                student.lastName + ", " + student.firstName,
              nameOfReviewingStudent:
                props.user.lastName + ", " + props.user.firstName,
              user: props.user._id,
              class: props.sprint.class,
              sprint: props.sprint._id,
              studentReviewed: state.reviewedStudent,
            },
            props.reviewingEvaluations
          );
        } catch (error) {
            console.error(error)
            alert('an error occurred', error)
        }
    }

    const getStudentName = () => {
        const student = props.classStudents.find(student => student._id === state.reviewedStudent);
        return student ? student.lastName + ", " + student.firstName : "";
    }

    useEffect(() => {
        if (props.authErrCode.editEvals.status === 201) {
            props.resetEvaluationStatus();
            navigate("/student");
        }
    }, [props.authErrCode.editEvals.status]);

    let loading = state.loading;
    let message = state.message;
    if (props.authErrCode.editEvals.status === 500) {
        loading = false;
        message = "An error occurred, please try again. If the problem persists, save your answers in a separate file and try again later.";
    }

    return (
        <div className="evaluationForm">
            <div className="backButton">
                <Link to="/student">
                    <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                    Return to Dashboard
                </Link>
            </div>
            <h1>{props.assignment.name} Survey</h1>
            <h2>Student Being Reviewed</h2>
            <SelectField
                hintText={"Student"}
                name="reviewedStudent"
                value={getStudentName()}
                iconStyle={{paddingLeft: "22px"}}
            >
                {getMappedStudents()}
            </SelectField>
            {props.sprint.questionAnswerTypePairs.some(questionAnswerPair => questionAnswerPair.answer === "Range") &&
                <h3>(For scale questions, 1=Strongly Disagree, 7=Strongly Agree)</h3>}
            {getMappedQuestionsAnswerPairs()}
            {
                loading ?
                    <img src={"/loading.svg"} alt="Loading..."/>
                    :
                    <button className="pink" onClick={handleSubmit}>Save</button>
            }
            <p>{message}</p>
        </div>
    );
}

export default connect(state => state.root, { addEvaluation, resetEvaluationStatus })(EvaluationForm);
